import { IAccount, IFeature } from '@localina/core';
import React, { useMemo } from 'react';
import { useGetAccount } from '../../api/queries/account';
import { useRestaurant } from '../../api/queries/restaurants';
import { AccountUtils } from '../../utils';

interface IProps {
    filter: IFeature | IFeature[] | ((account?: IAccount) => boolean);
    children: React.ReactNode;
    /** Defaults to the restaurant in the URL; pass one when working on another (e.g. in the wizard). */
    restaurantId?: string;
}

const UserFeature: React.FC<IProps> = ({ children, filter, restaurantId }) => {
    const accountQuery = useGetAccount({ enabled: false });
    const restaurantQuery = useRestaurant({ enabled: accountQuery.isSuccess });

    const available = useMemo(() => {
        const targetRestaurantId = restaurantId ?? restaurantQuery.data?.id;
        if (accountQuery.data && targetRestaurantId) {
            if (typeof filter === 'string') {
                return AccountUtils.hasFeature(filter, accountQuery.data, targetRestaurantId);
            }
            if (Array.isArray(filter)) {
                return filter.every((element) =>
                    AccountUtils.hasFeature(element, accountQuery.data, targetRestaurantId),
                );
            }
            return filter(accountQuery.data);
        }
        return false;
    }, [restaurantQuery.data, accountQuery.data, filter, restaurantId]);

    return available ? <>{children}</> : null;
};
export default UserFeature;
